<template>
  <PagesBusinessHeadIntro :title="title" :description="description" />
  <PagesBusinessTypeBusiness :type_icons="type_icons" />
  <PagesBusinessArticleBusiness :articles="articles" />
  <PartialsBenifitWidget />
  <PartialsSubscriberWidget />
</template>
<script lang="ts" setup>
import BusinessLocale from "~~/config/widgets/qr-code-for";

const qrCodeFor = new BusinessLocale();
const type_icons = qrCodeFor.type_icons;
const title = qrCodeFor.title;
const description = qrCodeFor.description;
const articles = qrCodeFor.articles_locale;

import moment from "moment";
import DataLocale from "~~/config/interface/DataLocale";

const seoheader = new DataLocale([
  {
    locale: "en",
    title: "Revolutionizing Business and Organizations with QR Code Technology",
    description:
      "QR codes revolutionize business operations by streamlining processes, improving security, and increasing efficiency. They're essential in inventory management and customer engagement, transforming how we do business.",
    keywords:
      "QR code management,QR code inventory,QR code marketing,QR code payments,QR code transactions,QR code security,QR code logistics,QR code tracking,QR code analytics,QR code business solutions",
  },
  {
    locale: "vi",
    title: "Cách công nghệ mã QR cách mạng hóa doanh nghiệp và tổ chức",
    description:
      "Công nghệ mã QR cách mạng hóa các hoạt động kinh doanh bằng cách tối ưu hóa quy trình, cải thiện bảo mật và tăng cường hiệu quả. Chúng là thiết yếu trong quản lý hàng tồn kho và tương tác với khách hàng, thay đổi cách chúng ta kinh doanh.",
    keywords:
      "Quản lý mã QR, Mã QR hàng tồn kho, Tiếp thị mã QR, Thanh toán mã QR, Giao dịch mã QR, Bảo mật mã QR, Vận chuyển mã QR, Theo dõi mã QR, Phân tích mã QR, Giải pháp kinh doanh mã QR",
  },
  {
    locale: "ja",
    title: "QRコード技術によるビジネスと組織の革命",
    description:
      "QRコード技術はプロセスを最適化し、セキュリティを向上させ、効率を高めることでビジネスの運営を革新しています。在庫管理や顧客エンゲージメントに欠かせないもので、ビジネスのやり方を変えています。",
    keywords:
      "QRコード管理、QRコード在庫、QRコードマーケティング、QRコード決済、QRコード取引、QRコードセキュリティ、QRコードロジスティクス、QRコードトラッキング、QRコードアナリティクス、QRコードビジネスソリューション",
  },
  {
    locale: "es",
    title:
      "Revolucionando negocios y organizaciones con la tecnología de códigos QR",
    description:
      "Los códigos QR están revolucionando las operaciones comerciales al optimizar procesos, mejorar la seguridad y aumentar la eficiencia. Son esenciales en la gestión de inventario y en la interacción con los clientes, transformando la forma en que hacemos negocios.",
    keywords:
      "Gestión de códigos QR, Inventario de códigos QR, Marketing de códigos QR, Pagos de códigos QR, Transacciones de códigos QR, Seguridad de códigos QR, Logística de códigos QR, Seguimiento de códigos QR, Analítica de códigos QR, Soluciones empresariales de códigos QR",
  },
  {
    locale: "de",
    title: "Geschäfts- und Organisationsrevolution mit QR-Code-Technologie",
    description:
      "QR-Codes revolutionieren Geschäftsabläufe durch Prozessoptimierung, verbesserte Sicherheit und höhere Effizienz. Sie sind unerlässlich in der Bestandsverwaltung und Kundenbindung und verändern die Art und Weise, wie wir Geschäfte machen.",
    keywords:
      "QR-Code-Verwaltung, QR-Code-Inventar, QR-Code-Marketing, QR-Code-Zahlungen, QR-Code-Transaktionen, QR-Code-Sicherheit, QR-Code-Logistik, QR-Code-Tracking, QR-Code-Analyse, QR-Code-Geschäftslösungen",
  },
  {
    locale: "fr",
    title:
      "Révolutionner les entreprises et les organisations avec la technologie QR Code",
    description:
      "Les codes QR révolutionnent les opérations commerciales en optimisant les processus, en améliorant la sécurité et en augmentant l'efficacité. Ils sont essentiels dans la gestion des stocks et l'engagement des clients, transformant ainsi la façon dont nous faisons des affaires.",
    keywords:
      "Gestion de code QR, Inventaire de code QR, Marketing de code QR, Paiements de code QR, Transactions de code QR, Sécurité de code QR, Logistique de code QR, Suivi de code QR, Analyse de code QR, Solutions d'affaires de code QR",
  },
  {
    locale: "it",
    title:
      "Rivoluzionare le attività e le organizzazioni con la tecnologia QR Code",
    description:
      "I codici QR rivoluzionano le operazioni aziendali semplificando i processi, migliorando la sicurezza e aumentando l'efficienza. Sono essenziali nella gestione degli inventari e nell'interazione con i clienti, trasformando il modo in cui facciamo affari.",
    keywords:
      "gestione codice QR, inventario codice QR, marketing codice QR, pagamenti codice QR, transazioni codice QR, sicurezza codice QR, logistica codice QR, tracciamento codice QR, analisi codice QR, soluzioni aziendali codice QR",
  },
  {
    locale: "pt",
    title: "Revolutionando negócios e organizações com a tecnologia QR Code",
    description:
      "Os códigos QR revolucionam as operações comerciais ao simplificar processos, melhorar a segurança e aumentar a eficiência. Eles são essenciais na gestão de inventários e no engajamento com os clientes, transformando a forma como fazemos negócios.",
    keywords:
      "gestão de código QR, inventário de código QR, marketing de código QR, pagamentos de código QR, transações de código QR, segurança de código QR, logística de código QR, rastreamento de código QR, análise de código QR, soluções de negócios de código QR",
  },
  {
    locale: "zh",
    title: "二维码技术改变商业和组织运营方式",
    description:
      "二维码技术可以优化流程、提高效率和加强安全性，正在改变许多行业的运营方式。它们在库存管理和客户互动方面至关重要，正在转变我们的商业方式。",
    keywords:
      "二维码管理，二维码库存，二维码营销，二维码支付，二维码交易，二维码安全，二维码物流，二维码跟踪，二维码分析，二维码商业解决方案",
  },
  {
    locale: "ja",
    title: "QRコード技術によるビジネスと組織の革新",
    description:
      "QRコード技術は、プロセスを効率化し、セキュリティを向上させ、多くの業界で運営方法を変革しています。在庫管理や顧客エンゲージメントに不可欠で、ビジネスのあり方を変えています。",
    keywords:
      "QRコード管理、QRコード在庫、QRコードマーケティング、QRコード決済、QRコード取引、QRコードセキュリティ、QRコードロジスティクス、QRコードトラッキング、QRコードアナリティクス、QRコードビジネスソリューション",
  },
]);

const datajd = useDataJd();
const meta = useMeta();

const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
const meta_tags = meta.metaTag({
  title: seoheader.data.title,
  description: seoheader.data.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/business.jpg"),
});
useHead({
  title: seoheader.data.title,
  meta: [
    { name: "description", content: seoheader.data.description },
    { name: "keywords", content: seoheader.data.keywords },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});
useSchemaOrg([
  defineWebPage({
    name: seoheader.data.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: seoheader.data.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/business.jpg"),
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      {
        item: {
          name: "QR Codes for Business",
          "@id": datajd.currentHost() + useRoute().fullPath,
        },
      },
    ],
  }),
]);
</script>
